import { useEffect } from 'react'

import { ProviderRevenueCat } from '@/pages/external/ExternalPremiumLogin/RevenueCatProvider'
import { RevenueCatPurchase } from '@/pages/external/RevenuecatCheckout'
import { eventTracker } from '@/config/trackingFunctions'
import { TRACKING_TYPES } from '@/constants/TrackingConstants'

export function HardSubscribe() {
  useEffect(() => {
    eventTracker(TRACKING_TYPES.HARD_SIGNUP_SUBSCRIBE_PAYWALL)
  }, [])

  return (
    <div className="flex w-full h-screen flex-col items-center justify-center">
      <div
        className={`flex flex-col w-full lg:w-[480px] gap-y-4 ml-0 transition-all duration-500 ease-in-out mb-20 lg:mb-8`}
      >
        <ProviderRevenueCat>
          <RevenueCatPurchase />
        </ProviderRevenueCat>
      </div>
    </div>
  )
}
